module.exports = require("@swa-ui/core/src/OptionListItem/OptionListItem.module.scss");